// User-facing role presentation is shared by the account menu and Command
// Center. Keep authorization in AuthContext/server/lib/roles.js; this module is
// display-only so the same role cannot acquire different labels or colors in
// different screens.
export const ROLE_LABELS = Object.freeze({
  admin: 'אדמין',
  hq_admin: 'בעלים / מטה',
  manager: 'מנהל',
  viewer: 'צופה',
});

export const ROLE_COLORS = Object.freeze({
  admin: '#1a56db',
  hq_admin: '#a94e08',
  manager: '#0d9488',
  viewer: '#6b7280',
});

export const ROLE_BADGE_TONES = Object.freeze({
  admin: 'blue',
  hq_admin: 'orange',
  manager: 'green',
  viewer: 'gray',
});
